// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './index.vue'


import "swiper/css/swiper.min.css";


import $ from 'jquery';
Vue.prototype.$ = $;
window.$ = $;

import {
    get,
    post,
} from '@/utils/request'


Vue.prototype.$get = get;
Vue.prototype.$post = post;


Vue.prototype.globalData = {
    refs: null
};

Vue.prototype.$showAlert = function(msg, callback) {
    var that = this;
    var html = '<div class="alert_page" ><div class="dialog"><div class="msg">' + msg + '</div><div class="btn"></div></div></div>';
    this.$(document.body).append(html);
    this.$(".alert_page .btn").click(function() {
        that.$(".alert_page").remove();
        if (callback) callback();
    });

};


new Vue({
    render: h => h(App)
}).$mount('#app')